<template>
  <div id="app" @click="isTimeOut">
    <router-view />
  </div>
</template>

<script>
import "@/css/index.css";
import "@/util/conversionDate.js";
export default {
  name: "App",
  data() {
    return {
      lastTime: null, //最后一次点击的时间
      currentTime: null, //当前点击的时间
      timeOut: 10 * 60 * 1000 //设置超时时间 十分钟(时间戳的形式)
    };
  },
  created() {
    this.lastTime = new Date().getTime();
  },
  methods: {
    isTimeOut() {
      this.currentTime = new Date().getTime();
      if (this.currentTime - this.lastTime > this.timeOut) {
        if (sessionStorage.getItem("backstageUser")) {
          sessionStorage.clear();
          localStorage.clear();
          this.$router.push({
            path: "/home/homepage"
          });
          this.$message.error("您已超过10分钟未操作系统，系统已自动退出登录！");
        } else {
          this.lastTime = new Date().getTime();
        }
      } else {
        this.lastTime = new Date().getTime();
      }
    }
  }
};
</script>

<style>
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue